export default __webpack_public_path__ + "static/media/music.f329d79c.mp3";